// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  npcId: __t.u64(),
  name: __t.string(),
  modelKey: __t.string(),
  posX: __t.f32(),
  posY: __t.f32(),
  posZ: __t.f32(),
  yaw: __t.f32(),
  scale: __t.f32(),
  configJson: __t.string(),
};
